/**
 * Pagination reset signal for the external PA orders table via an incrementing counter.
 */
import { useState } from "react";

/**
 * Provides a counter that, when incremented, signals the table to reset pagination to page 1.
 *
 * @returns The current reset count and its setter
 */
export const useExternalPaginationReset = () => {
  const [paginationResetCount, setPaginationResetCount] = useState(0);

  return { paginationResetCount, setPaginationResetCount };
};
